import React from 'react';
import PropTypes from 'prop-types';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';
import Loadable from 'common/libs/Loadable/Loadable';
import {
  TRANSACTION_DETAIL_TYPE_VIEW_TRANSACTION,
  TRANSACTION_DETAIL_TYPE_SUCCESS_BOOKING,
} from '../constants/transactionDetailConstants';
import { View } from 'react-native';

const BusTransactionDetailContainer = Loadable({
  loader: () =>
    import(/* webpackChunkName: "BusTransactionDetailContainer" */ '../containers/BusTransactionDetailContainer'),
  loading: DefaultLoadingScreen,
});

class BusTransactionDetailScreen extends React.Component {
  static propTypes = {
    navigation: PropTypes.shape({
      state: PropTypes.shape({
        params: PropTypes.shape({
          originLabel: PropTypes.string.isRequired,
          destinationLabel: PropTypes.string.isRequired,
          tripItineraryId: PropTypes.number.isRequired,
          pnrCode: PropTypes.string.isRequired,
        }).isRequired,
      }).isRequired,
    }).isRequired,
  };

  static navigationOptions = ({ navigation }) => {
    const title = BusTransactionDetailScreen.getPageTitle(navigation);
    const type = navigation.getParam(
      'type',
      TRANSACTION_DETAIL_TYPE_VIEW_TRANSACTION
    );
    if (type === TRANSACTION_DETAIL_TYPE_SUCCESS_BOOKING) {
      return {
        headerTitle: <HeaderOneLine title={title} />,
        headerLeft: <View />,
      };
    }

    return {
      headerTitle: <HeaderOneLine title={title} />,
    };
  };

  static getPageTitle = navigation => {
    const type = navigation.getParam(
      'type',
      TRANSACTION_DETAIL_TYPE_VIEW_TRANSACTION
    );
    if (type === TRANSACTION_DETAIL_TYPE_SUCCESS_BOOKING)
      return 'Pemesanan Berhasil!';
    const originLabel = navigation.getParam('originLabel', '');
    const destinationLabel = navigation.getParam('destinationLabel', '');
    return `${originLabel} → ${destinationLabel}`;
  };

  get transactionId() {
    const { navigation } = this.props;
    return navigation.getParam('tripItineraryId', '');
  }

  get isReservationList() {
    const { navigation } = this.props;
    return navigation.getParam('isReservationList', false);
  }

  render() {
    return (
      <BusTransactionDetailContainer
        id={this.transactionId}
        isReservationList={this.isReservationList}
        {...this.props}
      />
    );
  }
}

export default BusTransactionDetailScreen;
